import React from 'react'
import { useGetPermissions } from '../../../../layouts/customHook';
import RefundsApprovalConfigListing from './RefundsApprovalConfigListing';
import { PermisionDenied } from '../../../../views/pages/manage/common/commonComponents';


const RefundsApprovalConfigPage = () => {
  const userPermissions = useGetPermissions('refundApprovalConfig');
  return userPermissions ? <RefundsApprovalConfigListing userPermissions={userPermissions} /> : <PermisionDenied />

}

export default RefundsApprovalConfigPage